const COMMENT_ITEMS = [
  {
    name: '光影追梦人',
    time: '2小时前',
    rating: 5,
    text: '天美影视真的太流畅了！之前用别的平台看高清电影总是卡顿，自从朋友推荐了天美影视，画质清晰还不缓冲，追剧体验直接拉满。片源更新也很快，新上映的电影很快就有了。',
    tag: '流畅不卡顿',
  },
  {
    name: '剧荒拯救者',
    time: '5小时前',
    rating: 5,
    text: '作为一个重度追剧爱好者，天美影视的片库量真的让我惊喜。分类很全，从经典老片到最新热播剧都有，而且全部免费在线观看。高清画质加上流畅播放，每天都要来刷几集。',
    tag: '片源丰富',
  },
  {
    name: '深夜观影人',
    time: '1天前',
    rating: 4,
    text: '手机端体验非常好，躺在床上就能舒舒服服地看电影。画质清晰度有多个档位可选，网络不好的时候自动适配，很贴心。就是希望以后能加上弹幕功能，一个人看片有点寂寞哈哈。',
    tag: '移动端好用',
  },
  {
    name: '电影发烧友',
    time: '2天前',
    rating: 5,
    text: '一直在找能稳定看高清电影的网站，试过很多平台都不太满意，直到发现了天美影视。片源质量高，没有乱七八糟的广告弹窗，界面也很清爽。已经推荐给身边所有爱看电影的朋友了！',
    tag: '纯净无广告',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">用户评价</h2>
          <p className="mt-2 text-sm text-foreground-600">听听观影爱好者们怎么说</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-[960px] mx-auto">
          {COMMENT_ITEMS.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                  <span className="text-primary-600 text-sm font-bold">{item.name.charAt(0)}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.time}</div>
                </div>
                <div className="flex items-center gap-0.5">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i
                      key={i}
                      className={`text-xs ${i < item.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                    ></i>
                  ))}
                </div>
              </div>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3">{item.text}</p>
              <span className="inline-block px-2.5 py-1 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full whitespace-nowrap">
                {item.tag}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}